// extracted by mini-css-extract-plugin
export default {"root":"render-checkbox_root__fnQyA","iconBox":"render-checkbox_iconBox__TMbZj"};